export interface PaymentMethodOption {
  titleKey: string;
  subtitleKey?: string;
  type: string;
  specificType: string;
  iconKey: keyof typeof PAYMENT_METHOD_ICON_KEYS;
  hide?: boolean;
  hideOnNonApple?: boolean;
}

export const PAYMENT_METHOD_ICON_KEYS = {
  CARD: 'CARD',
  google: 'google',
  apple: 'apple',
  gimac: 'gimac',
  mobile: 'mobile',
  EUMM: 'EUMM',
  BANK: 'BANK',
} as const;

export const PAYMENT_METHOD_OPTIONS: PaymentMethodOption[] = [
  {
    titleKey: 'paymentMethods:creditAndDebitCards',
    subtitleKey: 'paymentMethods:cardSubtitle',
    type: 'CARD',
    specificType: 'CARD',
    iconKey: 'CARD',
    hide: false,
  },
  {
    titleKey: 'paymentMethods:googlePay',
    subtitleKey: 'paymentMethods:googlePaySubtitle',
    type: 'OTHER',
    specificType: 'google',
    iconKey: 'google',
    hide: false,
  },
  {
    titleKey: 'paymentMethods:applePay',
    subtitleKey: 'paymentMethods:applePaySubtitle',
    type: 'OTHER',
    specificType: 'apple',
    iconKey: 'apple',
    hide: false,
    hideOnNonApple: true,
  },
  {
    titleKey: 'paymentMethods:mobileMoney',
    subtitleKey: 'paymentMethods:mobileMoneySubtitle',
    type: 'GIMAC',
    specificType: 'gimac',
    iconKey: 'gimac',
    hide: false,
  },
  {
    titleKey: 'paymentMethods:mobileMoney',
    subtitleKey: 'paymentMethods:mobileMoneySubtitle',
    type: 'MOBILE_MONEY',
    specificType: 'mobile',
    iconKey: 'mobile',
    hide: false,
  },
  {
    titleKey: 'paymentMethods:expressUnion',
    subtitleKey: 'paymentMethods:expressUnionSubtitle',
    type: 'MOBILE_MONEY',
    specificType: 'EUMM',
    iconKey: 'EUMM',
    hide: true,
  },
  {
    titleKey: 'paymentMethods:bank',
    subtitleKey: 'paymentMethods:bankSubtitle',
    type: 'BANK',
    specificType: 'BANK',
    iconKey: 'BANK',
    hide: false,
  },
];

export function getAvailablePaymentMethodOptions(
  meansOfPayment: Array<{ type: string; active: boolean }> | undefined,
  isAppleDevice: boolean,
): PaymentMethodOption[] {
  if (!meansOfPayment?.length) return [];

  return PAYMENT_METHOD_OPTIONS.filter(option => {
    if (option.hide) return false;
    if (option.hideOnNonApple && !isAppleDevice) return false;
    return meansOfPayment.some(m => m.type.toLowerCase() === option.type.toLowerCase() && m.active);
  });
}
